import { api } from "./api";

// Signal de présence anonyme : alimente la vue « Visiteurs en ligne » de l'admin.
// Identifiant navigateur aléatoire (localStorage), aucune donnée personnelle.
const SID_KEY = "mt_presence_sid";

function sid() {
  let v = localStorage.getItem(SID_KEY);
  if (!v) {
    v = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
    localStorage.setItem(SID_KEY, v);
  }
  return v;
}

// Le suivi de pages vues (App.js) joint ce même identifiant : l'admin peut ainsi
// regrouper les pages parcourues par visiteur dans l'« Historique des visiteurs ».
export function getPresenceSid() {
  return sid();
}

let lastPath = "";
let lastSent = 0;

export function pingPresence(path) {
  if (!path || path.startsWith("/admin")) return;  // on mesure les visiteurs, pas l'admin
  const now = Date.now();
  if (path === lastPath && now - lastSent < 60000) return;  // même page : max 1 ping/min
  lastPath = path;
  lastSent = now;
  api.post("/presence", { sid: sid(), path }).catch(() => {});
}

// Rappel périodique tant que l'onglet est visible (montre que le visiteur est encore là)
export function startPresenceHeartbeat(getPath) {
  return setInterval(() => {
    if (document.visibilityState === "visible") {
      const p = getPath();
      if (p && !p.startsWith("/admin")) {
        api.post("/presence", { sid: sid(), path: p }).catch(() => {});
      }
    }
  }, 90000);
}
